/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { AdminDeposit } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import { CheckOutlined } from '@ant-design/icons'
import { Button, Popconfirm, Tooltip } from 'antd'
import { showNotification } from 'src/core/helpers'
import { useAppDispatch, useAppSelector, useWindowSize } from 'src/app/hooks'
import {
  resetValidateDepositState,
  validateDepositSelector,
  adminDepositsSelector,
  validateDeposit,
} from 'src/features'

const AdminDepositValidateButton: React.FC<{ deposit: AdminDeposit }> = ({ deposit }) => {
  const { t } = useTranslation()
  const { isMobile } = useWindowSize()
  const dispatch = useAppDispatch()
  const { data: oldDepositList } = useAppSelector(adminDepositsSelector)
  const { loading, currentDepositId, success } = useAppSelector(validateDepositSelector)
  const isLoading = loading && deposit.id === currentDepositId

  useEffect(() => {
    if (success && currentDepositId === deposit.id) {
      dispatch(resetValidateDepositState())
      showNotification('success', t('ValidateDeposits.Validated'))
    }
  }, [success])

  return <Popconfirm
    disabled={false}
    cancelText={t('general.Cancel')}
    placement={isMobile ? 'bottomLeft' : 'left'}
    okButtonProps={{ loading: isLoading }}
    cancelButtonProps={{ disabled: isLoading }}
    title={t('ValidateDeposits.SureValidate')}
    okText={isLoading ? t('ValidateDeposits.Validating') : t('general.Yes')}
    onConfirm={() => dispatch(validateDeposit(deposit.id, oldDepositList))}
  >
    <Tooltip title={t('ValidateDeposits.Validate')} color={'blue'}>
      <Button
        type='ghost'
        size='middle'
        shape='circle'
        loading={isLoading}
        className={`radius-100 ml-3`}
        icon={<CheckOutlined />}
      />
    </Tooltip>
  </Popconfirm>
}

export default AdminDepositValidateButton
